import * as Dialog from "@radix-ui/react-dialog";
import { ArrowUpRight, MapPin, X } from "lucide-react";
import { booking, clinics, ui } from "@/content";

export default function BookingModal({ open, onOpenChange, onCloseAutoFocus }) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="np-overlay fixed inset-0 z-[60] bg-forest/60 backdrop-blur-sm" />
        <Dialog.Content
          data-testid="booking-modal"
          onCloseAutoFocus={onCloseAutoFocus}
          className="np-modal fixed left-1/2 top-1/2 z-[61] w-[calc(100%-2rem)] max-w-lg -translate-x-1/2 -translate-y-1/2 rounded-[28px] bg-cream p-6 shadow-2xl sm:p-9"
        >
          <Dialog.Close
            data-testid="booking-modal-close"
            aria-label={ui.close}
            className="absolute right-4 top-4 grid h-11 w-11 place-items-center rounded-full text-ink/70 transition-colors hover:bg-sand hover:text-ink"
          >
            <X className="h-5 w-5" />
          </Dialog.Close>
          <p className="eyebrow">Boka tid</p>
          <Dialog.Title className="mt-2 font-serif text-3xl text-ink sm:text-4xl">{booking.title}</Dialog.Title>
          <Dialog.Description className="mt-3 text-sm text-muted sm:text-base">{booking.intro}</Dialog.Description>
          <ul className="mt-7 grid gap-3">
            {clinics.map((c) => (
              <li key={c.id}>
                <a
                  href={c.bookingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`booking-option-${c.id}`}
                  className="group flex items-center gap-4 rounded-2xl border border-line bg-white p-5 transition-[border-color,transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:border-pine hover:shadow-lg"
                >
                  <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-sage/60 text-forest">
                    <MapPin className="h-5 w-5" />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block font-serif text-2xl text-ink">{c.city}</span>
                    <span className="block truncate text-sm text-muted">{c.addressLines[c.id === "nacka" ? 1 : 0]}</span>
                    {c.id === "goteborg" && <span className="mt-1 block text-xs font-semibold text-pine">Läkaren är på plats cirka 1 gång/månad</span>}
                  </span>
                  <ArrowUpRight className="h-5 w-5 shrink-0 text-pine transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  <span className="sr-only">({ui.opensBokadirekt})</span>
                </a>
              </li>
            ))}
          </ul>
          <a
            href={booking.profileUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="booking-all-services-link"
            className="mt-6 inline-flex items-center gap-1 text-sm font-medium text-pine underline decoration-pine/30 underline-offset-4 hover:decoration-pine"
          >
            {booking.allServicesLabel}
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
